<template>
  <v-card>
    <!-- <v-card-title primary-title>
      <div>
        <div class="headline">Error</div>
        <span class="grey--text">An unexpected error occurred when saving your claim. Please try</span>
      </div>
    </v-card-title> -->
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-information</v-icon>
      <v-toolbar-title>System Information</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <div v-if="saveErrors.messages.length > 0" class="pb-3">
        <span class="info-dialog-msg-header">Oops something went wrong...</span>
        <v-spacer class="mt-2"></v-spacer>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in saveErrors.messages" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>
      <div v-if="saveErrors.fieldMessages.length > 0" class="pb-3">
        <span class="info-dialog-msg-header">Oops something went wrong...</span>
        <v-spacer class="mt-2"></v-spacer>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in saveErrors.fieldMessages" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  computed: {
    saveErrors() {
      return this.$store.state.claims.claimDetail.saveError
    }
  },
  methods: {
    doClose() {
      // revert the state
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.claimErrorMsgs {
  padding-left: 30px;
}
.showErrorMsgs {
  padding-left: 30px;
  color: red !important;
}
</style>
